import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface Emisor {
    id: string;
    nombre: string;
    tipoContribuyente: number;
    tipoRegimen?: number;
    numDocumento: string;
    digitoVerificador: number;
    direccion: string;
    numCasa: number;
    ciudadCodigo: string;
    ciudadNombre?: string;
    departamentoCodigo: string;
    departamentoNombre?: string;
    telefono: string;
    email: string;
    timbrado?: number;
    fechaInicioTimbrado?: string;
    establecimiento?: string;
    puntoExpedicion?: string;
    cSC1?: string;
    pathCertificado?: string;
    passwordCertificado?: string;
    nombreLogo?: string;
    tipoTransaccion?: number;
    tipoImpuestoAfectado?: number;
    establecimientos?: Array<{
        punto: string;
        email: string;
        telefono: string;
        direccion: string;
        numCasa: number;
        ciudadCodigo: string;
        ciudadNombre?: string;
        departamentoCodigo: string;
        departamentoNombre?: string;
    }>;
    actividadComercialId?: string;
}

export async function getEmisores(): Promise<Emisor[]> {
    await sleep(1000);
    const response = await api.get("emisor");
    return response.data;
}

export async function getEmisorLogo(id: string, fileName: string): Promise<File> {
    const response = await api.get(`emisor/${id}/logo`, { responseType: "blob" });
    const contentType = response.headers["content-type"] || "image/png";
    return new File([response.data], fileName, { type: contentType });
}

export function useGetEmisoresQuery(queryConfig: QueryConfig<Emisor[]> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getEmisores(),
        queryKey: ["emisores"],
    })
}

export interface GetEmisoresQueryProps {
    queryConfig?: QueryConfig<Emisor[]>,
    children?: (queryResult: QueryResult<Emisor[]>) => ReactNode
}

export function GetEmisoresQuery({
    children,
    queryConfig
}: GetEmisoresQueryProps) {
    const queryResult = useGetEmisoresQuery(queryConfig);
    return children && children(queryResult);
}
